module.exports = __webpack_public_path__ + "img/logo.839e7b4a.png";